// extracted by mini-css-extract-plugin
export default {"cls1":"CmjcMZeY0ovaqcTkNRfQ","cls2":"KCx6iUrN8MFYqoL2pCnZ CmjcMZeY0ovaqcTkNRfQ"};